export let hres6aeColumns = () => {
  let indexColumns = [
    {
      key: 'dtereq',
      name: '',
      labelCodapp: 'HRES6AEC1',
      labelIndex: '70',
      class: 'align-center',
      style: 'min-width: 120px;',
      dataType: 'date'
    }, {
      key: 'numseq',
      name: '',
      labelCodapp: 'HRES6AEC1',
      labelIndex: '80',
      class: 'align-center',
      style: 'min-width: 80px;'
    }, {
      key: 'dtework',
      name: '',
      labelCodapp: 'HRES6AEC1',
      labelIndex: '90',
      class: 'align-center',
      style: 'min-width: 120px;',
      dataType: 'date'
    }, {
      key: 'codshift',
      name: '',
      labelCodapp: 'HRES6AEC1',
      labelIndex: '100',
      class: 'align-center',
      style: 'min-width: 100px;'
    }, {
      key: 'timinout',
      name: '',
      labelCodapp: 'HRES6AEC1',
      labelIndex: '110',
      class: 'align-center',
      style: 'min-width: 200px;'
    }, {
      key: 'status',
      name: '',
      labelCodapp: 'HRES6AEC1',
      labelIndex: '140',
      style: 'min-width: 200px;'
    }, {
      key: 'remarkap',
      name: '',
      labelCodapp: 'HRES6AEC1',
      labelIndex: '150',
      style: 'min-width: 200px;'
    }, {
      key: 'desc_codappr',
      name: '',
      labelCodapp: 'HRES6AEC1',
      labelIndex: '160',
      style: 'min-width: 200px;'
    }, {
      key: 'desc_codempap',
      name: '',
      labelCodapp: 'HRES6AEC1',
      labelIndex: '170',
      style: 'min-width: 200px;'
    }
  ]

  let detailColumns = [
    {
      key: 'dtework',
      name: '',
      labelCodapp: 'HRES6AEC2',
      labelIndex: '40',
      class: 'align-center',
      style: 'min-width: 120px;',
      dataType: 'date'
    }, {
      key: 'typwork',
      name: '',
      labelCodapp: 'HRES6AEC2',
      labelIndex: '50',
      class: 'align-center',
      style: 'min-width: 50px;'
    }, {
      key: 'codshift',
      name: '',
      labelCodapp: 'HRES6AEC2',
      labelIndex: '60',
      class: 'align-center',
      style: 'min-width: 50px;'
    }, {
      key: 'hTimeIn',
      name: '',
      labelCodapp: 'HRES6AEC2',
      labelIndex: '70',
      class: 'align-center',
      style: 'min-width: 400px;',
      headerRow: 1,
      colspan: 2,
      rowspan: 1
    }, {
      key: 'dtein',
      name: '',
      labelCodapp: 'HRES6AEC2',
      labelIndex: '80',
      class: 'align-center',
      inlineType: 'date',
      headerRow: 2,
      colspan: 1,
      rowspan: 1,
      validateRules: 'requiredAnyWhenExistAny:dtein,flgEdit|date_format:DD/MM/YYYY',
      // validateRules: 'requiredAnyWhenExistAny:dtein,timin-dteout-timout-codreqst-remark|date_format:DD/MM/YYYY',
      eventName: 'dtein',
      dataType: 'date'
    }, {
      key: 'timin',
      name: '',
      labelCodapp: 'HRES6AEC2',
      labelIndex: '90',
      class: 'align-center',
      inlineType: 'time',
      headerRow: 2,
      colspan: 1,
      rowspan: 1,
      validateRules: 'requiredAnyWhenExistAny:timin,flgEdit|date_format:HH:mm',
      // validateRules: 'requiredAnyWhenExistAny:timin,dtein-dteout-timout-codreqst-remark|date_format:HH:mm',
      eventName: 'timin'
    }, {
      key: 'hTimeOut',
      name: '',
      labelCodapp: 'HRES6AEC2',
      labelIndex: '100',
      class: 'align-center',
      style: 'min-width: 400px;',
      headerRow: 1,
      colspan: 2,
      rowspan: 1
    }, {
      key: 'dteout',
      name: '',
      labelCodapp: 'HRES6AEC2',
      labelIndex: '110',
      class: 'align-center',
      inlineType: 'date',
      headerRow: 2,
      colspan: 1,
      rowspan: 1,
      validateRules: 'requiredAnyWhenExistAny:dteout,flgEdit|date_format:DD/MM/YYYY|after:dtein',
      // validateRules: 'requiredAnyWhenExistAny:dteout,dtein-timin-timout-codreqst-remark|date_format:DD/MM/YYYY|after:dtein',
      eventName: 'dteout',
      dataType: 'date'
    }, {
      key: 'timout',
      name: '',
      labelCodapp: 'HRES6AEC2',
      labelIndex: '120',
      class: 'align-center',
      inlineType: 'time',
      headerRow: 2,
      colspan: 1,
      rowspan: 1,
      // validateRules: 'requiredAnyWhenExistAny:timout,dtein-timin-dteout-codreqst-remark|date_format:HH:mm',
      validateRules: 'requiredAnyWhenExistAny:timout,flgEdit|date_format:HH:mm',
      eventName: 'timout'
    }, {
      key: 'codreqst',
      name: '',
      labelCodapp: 'HRES6AEC2',
      labelIndex: '130',
      inlineType: 'select',
      inlineDropdown: {},
      style: 'min-width: 150px;',
      validateRules: 'requiredAnyWhenExistAny:codreqst,flgEdit'
      // validateRules: 'requiredAnyWhenExistAny:codreqst,dtein-timin-dteout-timout-remark'
    }, {
      key: 'remark',
      name: '',
      labelCodapp: 'HRES6AEC2',
      labelIndex: '150',
      class: 'align-center',
      inlineType: 'textarea',
      style: 'min-width: 200px;',
      validateRules: 'requiredAnyWhenExistAny:remark,flgEdit|max:200'
      // validateRules: 'requiredAnyWhenExistAny:remark,dtein-timin-dteout-timout-codreqst|max:200'
    }, {
      key: 'hQty',
      name: '',
      labelCodapp: 'HRES6AEC2',
      labelIndex: '160',
      class: 'align-center text-red',
      style: 'min-width: 300px;',
      headerRow: 1,
      colspan: 3,
      rowspan: 1
    }, {
      key: 'qtylate',
      name: '',
      labelCodapp: 'HRES6AEC2',
      labelIndex: '170',
      class: 'align-center text-red',
      headerRow: 2,
      colspan: 1,
      rowspan: 1
    }, {
      key: 'qtyearly',
      name: '',
      labelCodapp: 'HRES6AEC2',
      labelIndex: '180',
      class: 'align-center text-red',
      headerRow: 2,
      colspan: 1,
      rowspan: 1
    }, {
      key: 'qtyabsent',
      name: '',
      labelCodapp: 'HRES6AEC2',
      labelIndex: '190',
      class: 'align-center text-red',
      headerRow: 2,
      colspan: 1,
      rowspan: 1
    }, {
      key: 'desc_staappr',
      name: '',
      labelCodapp: 'HRES6AEC2',
      labelIndex: '195',
      style: 'min-width: 200px;'
    }
  ]

  let popupTableColumns = [
    {
      key: 'dtework',
      name: '',
      labelCodapp: 'STDATTEN',
      labelIndex: '30',
      class: 'align-center',
      style: 'min-width: 100px;',
      dataType: 'date'
    }, {
      key: 'typwork',
      name: '',
      labelCodapp: 'STDATTEN',
      labelIndex: '40',
      class: 'align-center',
      style: 'min-width: 80px;'
    }, {
      key: 'codshift',
      name: '',
      labelCodapp: 'STDATTEN',
      labelIndex: '50',
      class: 'align-center',
      style: 'min-width: 80px;'
    }, {
      key: 'timsten',
      name: '',
      labelCodapp: 'STDATTEN',
      labelIndex: '60',
      class: 'align-center',
      style: 'min-width: 100px;'
    }, {
      key: 'hDtetimin',
      name: '',
      labelCodapp: 'STDATTEN',
      labelIndex: '70',
      class: 'align-center',
      style: 'min-width: 200px;',
      headerRow: 1,
      colspan: 2,
      rowspan: 1
    }, {
      key: 'dtein',
      name: '',
      labelCodapp: 'HRES6AEC2',
      labelIndex: '80',
      class: 'align-center',
      style: 'min-width: 120px;',
      headerRow: 2,
      colspan: 1,
      rowspan: 1,
      dataType: 'date'
    }, {
      key: 'timin',
      name: '',
      labelCodapp: 'HRES6AEC2',
      labelIndex: '90',
      class: 'align-center',
      style: 'min-width: 80px;',
      headerRow: 2,
      colspan: 1,
      rowspan: 1
    }, {
      key: 'hDtetiout',
      name: '',
      labelCodapp: 'STDATTEN',
      labelIndex: '80',
      class: 'align-center',
      style: 'min-width: 200px;',
      headerRow: 1,
      colspan: 2,
      rowspan: 1
    }, {
      key: 'dteout',
      name: '',
      labelCodapp: 'HRES6AEC2',
      labelIndex: '110',
      class: 'align-center',
      style: 'min-width: 120px;',
      headerRow: 2,
      colspan: 1,
      rowspan: 1,
      dataType: 'date'
    }, {
      key: 'timout',
      name: '',
      labelCodapp: 'HRES6AEC2',
      labelIndex: '120',
      class: 'align-center',
      style: 'min-width: 80px;',
      headerRow: 2,
      colspan: 1,
      rowspan: 1
    }, {
      key: 'atmfile',
      name: '',
      labelCodapp: 'STDATTEN',
      labelIndex: '90',
      class: 'align-center',
      style: 'min-width: 200px;'
    }
  ]

  return {
    en: {
      index: indexColumns,
      detail: detailColumns,
      detailPopup: popupTableColumns
    },
    th: {
      index: indexColumns,
      detail: detailColumns,
      detailPopup: popupTableColumns
    }
  }
}

export let hres6aeMaxRowspan = {
  index: 1,
  detail: 2,
  detailPopup: 2
}



// WEBPACK FOOTER //
// ./src/assets/columns/hres6ae.js